import { useEffect, useRef, useState } from "react"

import { Trans } from "gatsby-plugin-react-i18next"
import styled from "styled-components"

import RoundButton from "components/buttons/RoundButton"
import colors from "styles/colors"
import easing from "styles/easing"
import media from "styles/media"
import text from "styles/text"

export default function DropDown2({
  data,
}: {
  data: {
    title: string
    items?: string[]
    list?: {
      name: string;
      link: string;
    }[]
  }
}) {
  const [open, setOpen] = useState(false)
  const [height, setHeight] = useState<undefined | number>(0)
  const contentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (contentRef.current) {
      setHeight(contentRef.current.getBoundingClientRect().height)
    } else {
      return
    }

    const handleResize = () => {
      setHeight(contentRef.current?.getBoundingClientRect()?.height)
    }
    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [open])

  const items = data.items? data.items.map(item => (
    <Item key={`dropdown2-${item}`}>
      <Trans>{item}</Trans>
    </Item>
  )):data.list?.map((list)=>(
    <Item key={`dropdown2-${list}`}> <A
    
    href={list.link}
  >
    <Trans>{list.name}</Trans>
  </A></Item>
  )
  )
  return (
    <Wrapper>
      <TitleRow onClick={() => setOpen(!open)} role="presentation">
        <Title>
          <Trans>{data.title}</Trans>
        </Title>
        <RoundButton
          small
          blue
          dropDown
          onClick={() => {}}
          dropDownOpen={open}
        />
      </TitleRow>
      <Items ref={contentRef} opn={open}>
        {items}
      </Items>
      <ItemsGhost height={height} opn={open} />
    </Wrapper>
  )
}

const Item = styled.p`
  ${text.bodyS}
  color: ${colors.blue200};
`

const Wrapper = styled.div`
  width: 100%;
  ${media.fullWidth} {
    min-height: 46px;
    border-width: 1px;
  }
  ${media.desktop} {
    min-height: 2.771vw;
    border-width: 0.06vw;
  }
  ${media.tablet} {
    border-width: 0.098vw;
  }
  ${media.mobile} {
    border-width: 0.267vw;
  }
  border-top: ${colors.seaFoam100} solid;
  overflow-y: hidden;
  position: relative;
`

const TitleRow = styled.div`
  ${media.fullWidth} {
    margin-top: 10px;
  }
  ${media.desktop} {
    margin-top: 0.602vw;
  }
  ${media.tablet} {
    margin-top: 0.977vw;
  }
  ${media.mobile} {
    margin-top: 2.667vw;
  }
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
`

const Title = styled.h3`
  ${text.captionKicker}
  color: ${colors.seaFoam800};
`

const Items = styled.div<{ opn: boolean }>`
  ${media.fullWidth} {
    margin: 10px 0;
  }
  ${media.desktop} {
    margin: 0.602vw 0;
  }
  ${media.tablet} {
    margin: 0.977vw 0;
  }
  ${media.mobile} {
    margin: 2.667vw 0;
  }
  display: flex;
  flex-direction: column;
  opacity: ${props => (props.opn ? 1 : 0)};
  transition-duration: 300ms;
  transition-timing-function: ${easing.main};
  overflow-y: hidden;
  position: absolute;
`

const ItemsGhost = styled.div<{ height: undefined | number; opn: boolean }>`
  height: ${props => (props.opn ? props.height : 0)}px;
  transition: height 300ms ${easing.button};
  ${media.fullWidth} {
    margin: 10px 0;
  }
  ${media.desktop} {
    margin: 0.602vw 0;
  }
  ${media.tablet} {
    margin: 0.977vw 0;
  }
  ${media.mobile} {
    margin: 2.667vw 0;
  }
`
export const A = styled.a`
  color: ${colors.blue400};
`